

import React, { memo } from 'react';

import cx from 'classnames';
import Icon from '../Icon';
import './_text.scss';
































































const textTypes = {
  heading1: { element: 'h1', iconSize: 40 },
  heading2: { element: 'h2', iconSize: 30 },
  heading3: { element: 'h3', iconSize: 25 },
  heading4: { element: 'h4', iconSize: 20 },
  heading5: { element: 'h5', iconSize: 15 },
  normal14: { element: 'p', iconSize: 15 },
  body: { element: 'p', iconSize: 15 },
  caption: { element: 'p', iconSize: 15 },
  timestamp: { element: 'p', iconSize: 15 },
  label: { element: 'p', iconSize: 15 },
  placeholder: { element: 'p', iconSize: 15 },
  subtitle: { element: 'p', iconSize: 15 },
  button: { element: 'span', iconSize: 15 },
  details: { element: 'span', iconSize: 15 },
  link: { element: 'span', iconSize: 15 }
};

function getTextEl(props) {
  const textType = Object.keys(textTypes).find((type) => props[type]) || 'body';
  const { element, iconSize } = textTypes[textType];

  return { type: textType, TextEl: element, iconSize };
}

function getDagger({ suffix, double } = {}) {
  const classType = suffix ? 'suffix' : 'prefix';

  return <sup className={`text__${classType}-dagger`}>{double ? '†' : '*'}</sup>;
}

function Text({
  children,
  className,
  disabled,
  noMargin,
  darkTheme,
  prefixDagger,
  prefixDoubleDagger,
  suffixDagger,
  suffixDoubleDagger,
  required,
  highlighted,
  success,
  danger,
  warning,
  neutral,
  block,
  ellipsisOverflow,
  centered,
  prefixIcon,
  prefixSize,
  prefixIconColor = 'denim',
  prefixIconContent,
  suffixIcon,
  suffixSize,
  suffixIconColor = 'denim',
  helpText,
  helpId,
  style,
  ...props
}) {
  const { type, TextEl, iconSize } = getTextEl(props);

  if (highlighted && type !== 'body') {
    /* eslint-disable no-console */
    console.warn('You can only highlight body text.');
  }

  return (
    <TextEl
      style={style}
      className={cx(
        'text',
        `text--${type}`,
        {
          'text--disabled': disabled,
          'text--no-margin': noMargin && typeof noMargin !== 'string',
          'text--no-margin-bottom': noMargin === 'bottom',
          'text--no-margin-top': noMargin === 'top',
          'text--dark-theme': darkTheme,
          'text--block': block,
          'text--ellipsis-overflow': ellipsisOverflow,
          'text--centered': centered,
          'text--highlighted': type === 'body' && highlighted,
          'text--success': success,
          'text--danger': danger,
          'text--warning': warning,
          'text--neutral': neutral
        },
        className
      )}>

      {prefixDagger && getDagger()}
      {prefixDoubleDagger && getDagger({ double: true })}
      {
      prefixIconContent ||
      prefixIcon && type !== 'button' &&
      <Icon className="text__prefix-icon" name={prefixIcon} color={prefixIconColor} size={prefixSize || iconSize} />}


      {children}
      {
      suffixIcon && type !== 'button' ?
      <Icon className="text__suffix-icon" name={suffixIcon} color={suffixIconColor} size={suffixSize || iconSize} /> :
      null}

      {
      helpText && helpId && type !== 'button' ?
      <Icon className="text__suffix-icon" name="info" color="regent" tooltipId={`text-info-${helpId}`} tooltipLabel={helpText} size={20} /> :
      null}

      {required && <span className="text__asterisk">*</span>}
      {suffixDagger && getDagger({ suffix: true })}
      {suffixDoubleDagger && getDagger({ suffix: true, double: true })}
    </TextEl>);

}

Text.displayName = 'Text';

export default memo(Text);